/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
const d3 = require('d3')

const DURING_AF_COLOR = '#EA4524';
const NOT_DURING_AF_COLOR = '#449B23';



exports.createHistogramBarChart = (rawData,thresholds,onClick,width,height,type) => {
 //return d3.create('svg')
  const data = [...rawData.histogram].filter((e, i) => {
    return 0 < i && i < rawData.histogram.length - 1;
  });
  
  const is_histogram_during_af = rawData.is_af;

  const margin = { top: 40, right: 30, bottom: 40, left: 50 };
  const x = d3
    .scaleLinear()
    .domain([30, 170])
    // .nice()
    .range([margin.left, width - margin.right]);

  const y = d3
    .scaleLinear()
    .domain([0, 100])
    // .nice()
    .range([height - margin.bottom, margin.top]);

  const xAxis = (g) =>
    g
      .attr('transform', `translate(0,${height - margin.bottom})`)
      .call(
        d3
          .axisBottom(x)
          .tickValues([40, 60, 80, 100, 120, 140, 160])
          .tickSize(0)
          .tickPadding(10)
      );

  const yAxis = (g) =>
    g
      .attr('transform', `translate(${margin.left},0)`)
      .call(d3.axisLeft(y).tickValues(d3.scaleLinear().domain(y.domain()).ticks(5))
      .tickFormat(d => d ? d + '%' : '')
      .tickSize(0)
      .tickPadding(10))
      .call(g => g.selectAll(".tick line").clone()
        .attr('transform', (d, i) => `translate(${d ? 0 : -30},0)`)
        .attr("stroke-opacity", (d) => d ? 0.2 : 1)
        .attr("x2", width - margin.left - margin.right))
        
      .call((g) => g.select('.domain').remove());

  var histogram = d3
    .bin()
    .value(function (d) {
      return d.price;
    }) // I need to give the vector of value
    .domain(x.domain()) // then the domain of the graphic
    .thresholds(x.ticks(42)); // then the numbers of bins

  // var bins = histogram(data);
  const displayPercentAboveOne = (e) => {
    //this condition for display bins only above 1% is by Eldad order
    const p = (e * 100) / rawData.counter
    return p >= 1 ? p : 0
  }
  var bins = data.map((e, i) => {
    return { x0: i * 5 + 30, x1: i * 5 + 35, percent: displayPercentAboveOne(e) };
  });
  const svg = d3
    .create('svg')
    // .attr("viewBox", [0, 0, width, height])
    .attr('width', width)
    .attr('height', height);

  svg.append('g').call(xAxis); //.selectAll('.tick text').call(wrap, x.ticks());

  svg.append('g').call(yAxis);

  const g = svg
    .append('g')
    .selectAll('g')
    .data(bins)
    .enter()
    .append('rect')
    .attr('x', 1)
    .attr('transform', function (d) {
      return 'translate(' + x(d.x0) + ',' + y(d.percent) + ')';
    })
    .attr('width', function (d) {
      return x(d.x1) - x(d.x0) - 3;
    })
    .attr('height', function (d) {
      return height - y(d.percent) - margin.bottom;
    })
    .style('fill', () => {
      return type=== 'af-report-chart' ? DURING_AF_COLOR : NOT_DURING_AF_COLOR;
    });
  const gLegend = svg.append('g').attr('transform', (d) => `translate(1050,${margin.top - 15})`);

  return svg.node();
};

